import { Form, FormGroup, H3, Input, Select } from '@bigcommerce/big-design';
import { CreditCardForm } from './PaymentTypes/creditCardForm';

function FormInputs({ inputs, payment, setPaymentInfo }) {
	return inputs.map(({ displayName, value, required, max }) => (
		<FormGroup key={value}>
			<Input
				label={displayName}
				type="text"
				required={required}
				maxLength={max || 524288}
				value={payment?.[value] ?? ''}
				onChange={(e) => setPaymentInfo(value, e.target.value)}
			/>
		</FormGroup>
	));
}

const paymentOptions = [
	{ value: 'Amazon', content: 'Amazon' },
	{ value: 'Credit Card', content: 'Credit Card' },
	{ value: 'Gift Certificate', content: 'Gift Certificate' },
	{ value: 'Manual', content: 'Manual Order' },
];
const amazonInputs = [
	{ displayName: 'Order ID', value: 'order_id' },
	{ displayName: 'Ship By', value: 'ship_by' },
];
const giftCardInputs = [
	{
		displayName: 'Gift Certificate Code',
		value: 'gift_certificate_number',
		required: true,
	},
];
const customerInputs = [
	{ displayName: 'Shipping Charge', value: 'shipping_charge' },
	{ displayName: 'Shipping Description', value: 'description' },
	{ displayName: 'Shipping Account', value: 'shipping_account' },
	{ displayName: 'Customer PO', value: 'po_number' },
	{ displayName: 'Associated Order ID', value: 'associated_order_id' },
];

export function PaymentDetails(props) {
	const { onOptionChange, payment, setPaymentInfo } = props;

	return (
		<>
			<H3>Payment Details</H3>
			<Form>
				<FormGroup>
					<Select
						onOptionChange={onOptionChange}
						options={paymentOptions}
						value={payment?.payment_type}
						placeholder="Select Payment Type"
						filterable={false}
						required
					/>
				</FormGroup>
				{payment?.payment_type === 'Credit Card' && (
					<CreditCardForm
						payment={payment}
						setPaymentInfo={setPaymentInfo}
					/>
				)}
				{payment?.payment_type === 'Amazon' && (
					<FormInputs
						payment={payment}
						inputs={amazonInputs}
						setPaymentInfo={setPaymentInfo}
					/>
				)}
				{payment?.payment_type === 'Gift Certificate' && (
					<FormInputs
						payment={payment}
						inputs={giftCardInputs}
						setPaymentInfo={setPaymentInfo}
					/>
				)}
				<FormInputs
					payment={payment}
					inputs={customerInputs}
					setPaymentInfo={setPaymentInfo}
				/>
			</Form>
		</>
	);
}
